function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Halloween = ({
  style,
  color,
  ...rest
}) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 239.7 240",
  style: {
    width: 50,
    height: 50,
    ...style
  }
}, rest), /*#__PURE__*/React.createElement("path", {
  d: "M154.5,156.3c-0.1-0.6,0.6-0.9,1-0.5l13.2,14.4c0.2,0.2,0.4,0.2,0.7,0.1l17.7-8.1c0.5-0.2,1,0.3,0.8,0.8 l-9.6,17c-0.1,0.2-0.1,0.5,0.1,0.7l13.2,14.4c0.4,0.4,0,1.1-0.6,1l-19.1-3.9c-0.3-0.1-0.5,0.1-0.6,0.3l-9.6,17 c-0.3,0.5-1,0.3-1.1-0.2l-2.2-19.4c0-0.3-0.2-0.5-0.5-0.5l-19.1-3.9c-0.6-0.1-0.7-0.9-0.1-1.1l17.7-8.1c0.2-0.1,0.4-0.4,0.3-0.6 L154.5,156.3z",
  fill: "#EEC46A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.6,55.8c-0.1-0.6,0.6-0.9,1-0.5l6.3,6.8c0.2,0.2,0.4,0.2,0.7,0.1l8.5-3.9c0.5-0.2,1,0.3,0.8,0.8l-4.6,8.1 c-0.1,0.2-0.1,0.5,0.1,0.7l6.3,6.8c0.4,0.4,0,1.1-0.6,1l-9.1-1.8c-0.3-0.1-0.5,0.1-0.6,0.3l-4.6,8.1c-0.3,0.5-1,0.3-1.1-0.2 l-1.1-9.2c0-0.3-0.2-0.5-0.5-0.5L94,70.7c-0.6-0.1-0.6-0.9-0.1-1.1l8.5-3.9c0.2-0.1,0.4-0.4,0.3-0.6L101.6,55.8z",
  fill: "#EEC46A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3,71.4c-0.1-0.6,0.6-0.9,1-0.5L30.6,81c0.2,0.2,0.4,0.2,0.7,0.1l12.5-5.7c0.5-0.2,1,0.3,0.8,0.8l-6.8,12 c-0.1,0.2-0.1,0.5,0.1,0.7l9.3,10.1c0.4,0.4,0,1.1-0.6,1l-13.5-2.7c-0.3-0.1-0.5,0.1-0.6,0.3l-6.8,12c-0.3,0.5-1,0.3-1.1-0.2 l-1.6-13.7c0-0.3-0.2-0.5-0.5-0.5L9.1,92.5c-0.6-0.1-0.7-0.9-0.1-1.1l12.5-5.7c0.2-0.1,0.4-0.4,0.3-0.6L20.3,71.4z",
  fill: "#EEC46A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.1,149.2l-23.3-23.3c0,0-14.3-4.1-28.5,0c-8.9,2.6-20.8,11.7-20.8,11.7L0,179l11.7-5.2l-8.4,17.5l22-5.8 l-7.8,15.6l13-7.1L22,218.6l24-9.7l-6.5,13.6l14.9-8.4l-5.2,22.7l16.2-9.1L62.3,240l38.9-39.6c0,0,10.3-13.3,13-23.3 C117.6,164.1,114.1,149.2,114.1,149.2z",
  fill: color
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.1,177.1c3.4-13,0-27.9,0-27.9l-11.7-11.7L22,218.6l24-9.7l-6.5,13.6l14.9-8.4l-5.2,22.7l16.2-9.1 L62.3,240l38.9-39.6C101.2,200.4,111.5,187.2,114.1,177.1z",
  fill: color
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.4,1c1.4-1.4,3.6-1.4,5,0l3.2,3.2c1.4,1.4,1.4,3.6,0,5L130.2,118l-8.3-8.2L230.4,1z",
  fill: "#009ADF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98,118.6l22.7,22.2c1.4,1.4,1.4,3.6,0.1,5l-2.3,2.3c-1.4,1.4-3.6,1.4-5,0.1L90.7,126c-1.4-1.4-1.4-3.6-0.1-5 l2.3-2.3C94.3,117.3,96.6,117.3,98,118.6z",
  fill: "#EEC46A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.2,118L238.7,9.3c1.4-1.4,1.4-3.6,0-5L237,2.7L126,113.9L130.2,118z",
  fill: "#0060A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105,108.4c-4.1,3.2-6.5,11.7-6.5,11.7l11,10.7l11,10.7c0,0,9.5-2.3,12.3-7.1c1.5-2.5,1.9-4.2,1.9-7.1 c0-2.9-1.9-7.1-1.9-7.1l-6.5-6.5l-9.1-8.4c0,0-3.2-0.3-5.2,0C109.2,105.6,107.5,106.5,105,108.4z",
  fill: color
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.9,127.2c0-2.9-1.9-7.1-1.9-7.1l-6.5-6.5l-16.9,17.2l11,10.7c0,0,9.5-2.3,12.3-7.1 C134.4,131.8,134.9,130.1,134.9,127.2z",
  fill: color
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.7,147.1l-0.4,0.3c-3,1.8-6.1,3.6-9.1,5.3c-0.4,0.2-0.6,0.5-0.5,0.9c0.1,1.1,0,0.9,0.9,1.5 c0.3,0.2,0.7,0.3,1.1,0c2.8-1.7,5.6-3.3,8.4-5l0.5-0.3c0,0.1,0,0.2,0,0.3v15.2c0,0.5-0.3,1-0.7,1.2l-9.4,5.6 c-1.4,0.8-2.7,1.7-4.1,2.5c-0.5,0.3-1.1,0.3-1.6,0c-4.5-2.7-9-5.4-13.5-8.1c-0.5-0.3-0.9-0.8-0.8-1.4c0-5,0-9.9,0-14.8 c0-0.1,0-0.3,0-0.5l0.5,0.2l12.8,7.5c0.3,0.1,0.5,0.4,0.4,0.8c0,3.7,0,7.4,0,11v0.4c0,0.2,0.1,0.5,0.3,0.6l0.7,0.4 c0.2,0.1,0.5,0.1,0.7,0l0.7-0.4c0.2-0.1,0.4-0.3,0.4-0.6c0-0.1,0-0.2,0-0.3V157c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.3-0.5l-1-0.6 l-13.9-8.2l-0.4-0.3l0.3-0.2l13.1-7.2c0.5-0.3,1.1-0.3,1.6,0c4.4,2.4,8.7,4.8,13.1,7.2L69.7,147.1z",
  fill: "#FFFFFF"
}));

export default Halloween;